<footer *ngIf="!processingLogin" class="dds__default-footer dds__mt-20" style="margin-top:0rem" data-toggle="dds__footer" [ngClass]="{'footer-fixed' : !navShown}">
  <nav class="dds__footer-legal-nav">
  <div class="dds__container">
  <ul>
  <li>
  <a target="_blank" href="//www.dell.com/learn/us/en/uscorp1/site-terms-of-use-copyright">© 2022 Dell</a>
  </li>
  <li>
  <a target="_blank" href="//www.dell.com/learn/us/en/uscorp1/terms-of-sale">Terms of Sale</a>
  </li>
  <li>
  <a target="_blank" href="//www.dell.com/learn/us/en/uscorp1/policies-privacy">Privacy Statement</a>
  </li>
  <li>
  <a target="_blank" href="//www.dell.com/learn/us/en/uscorp1/policies-ads-and-emails">Ads &amp; Emails</a>
  </li>
  <li>
  <a target="_blank" href="//www.dell.com/learn/us/en/uscorp1/terms">Legal &amp; Regulatory</a>
  </li>
  <li>
  <a target="_blank" href="//corporate.delltechnologies.com/en-us/social-impact.htm">Social Impact</a>
  </li>
  <li>
  <a target="_blank" href="//corporate.delltechnologies.com/en-us/social-impact/advancing-sustainability/how-to-recycle.htm">Product Recycling</a>
  </li>
  <li>
  <a target="_blank" href="//www.dell.com/learn/us/en/uscorp1/legal_docs/dell-modern-slavery-statement.pdf">Anti-Slavery &amp; Human Trafficking</a>
  </li>
  <li>
  <a target="_blank" href="//www.dell.com/support/contents/en-us/category/Contact-Information">Contact Us</a>
  </li>
  <li>
  <a target="_blank" href="//www.dell.com/en-us/sitemap">Site Map</a>
  </li>
  </ul>
  </div>
  </nav>
  </footer>
